import React from "react";
import { useNavigate } from "react-router-dom";
import "../scss/motoServices.css";

const MotoDoctorHero = () => {
   const navigate = useNavigate();

   const handleBookNow = () => {
     navigate("/rider");
   };
  return (
    <section className="moto-hero">
      <div className="moto-container">
        <h1>Motorcycle Roadside Assistance & Doorstep Bike Service in Chennai</h1>
        <p className="highlight">MotoDoctor offers complete two-wheeler support across Chennai:</p>

        <ul className="moto-features">
          <li>
            <strong>Emergency Roadside Assistance (24/7):</strong> Flat tire, battery jumpstart, starting trouble, fuel
            delivery & accident support.
          </li>
          <li>
            <strong>On-Demand Doorstep Mechanics:</strong> General service, oil change, electrical & mechanical repairs.
          </li>
          <li>
            <strong>Pickup & Drop Service:</strong> We collect, service & deliver your bike.
          </li>
          <li>
            <strong>Towing & Transport:</strong> Safe, secure towing anywhere in Chennai.
          </li>
        </ul>

        <p className="trust">
          With verified mechanics, fast response, and fair pricing, MotoDoctor keeps your ride stress-free.
        </p>

        <div className="moto-cta">
          <button className="cta-btn" onClick={handleBookNow}>
            👉 Book Service Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default MotoDoctorHero;
